import livingSkyDesktop from './assets/livingSkyDesktop.jpg'
import livingSkyMobile from './assets/livingSkyMobile.jpg'
import swamDesktop from './assets/swamDesktop.jpg'
import swamMobile from './assets/swamMobile.jpg'
import analogXDesktop from './assets/analogXDesktop.jpg'
import analogXMobile from './assets/analogXMobile.jpg'

export const data = [
  {
    title: 'MNTRA/OUTER ECHO Living Sky',
    description:
      'Spatial audio reverb that defies physics by combining High-Order Ambisonics processing with new extended-range ultrasonic convolution',
    imageDesktop: livingSkyDesktop,
    imageMobile: livingSkyMobile,
    textFirst: false,
    link: 'https://www.mntra.io/living-sky/?srsltid=AfmBOoqSlVI1B2r1q02IptEfzOT0ibsT7uoOXHTJqgdN096k3NwyELtk',
    linkText: 'Discover',
  },
  // {
  //   title: 'Audio Modeling SWAM (Synchronous Waves Acoustic Modeling)',
  //   description:
  //     'A next-gen sampler that combines Physical and Behavioral Modeling with Multi-Vector/Phase-Synchronous Sample-Morphing',
  //   imageDesktop: swamDesktop,
  //   imageMobile: swamMobile,
  //   textFirst: true,
  //   link: 'https://audiomodeling.com/',
  //   linkText: 'Discover',
  // },
  {
    title: 'AnalogX Genesis',
    description:
      'Genesis will run with near-zero CPU strain while maintaining the uncompromising sound quality we’re known for',
    imageDesktop: analogXDesktop,
    imageMobile: analogXMobile,
    textFirst: true,
    link: 'https://analogxai.company.site/',
    linkText: 'Discover',
  },
]
